import script from "./BacktestPoolTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BacktestPoolTable.vue?vue&type=script&setup=true&lang=js"

import "./BacktestPoolTable.vue?vue&type=style&index=0&id=b7caaf12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7caaf12"]])

export default __exports__